<div class="at-tos-text">
  <div class="at-tos-title">
    {{app.text['tos']['terms-of-service']}}
  </div>
  <span *ngFor="let line of app.text['tos']['full-tos']">
    {{line}}
  </span>
</div>
